import { useState } from 'react';

import { FlexAligner, ModalFooter, ModalHeader } from '@scaleaq/scaleui';
import { useTranslation } from 'react-i18next';

import { LanguageSelector } from '@/components/LanguageSelector.tsx';
import { GamepadLayoutScreen } from '@/pages/GamepadLayoutScreen.tsx';
import { ModalControllerType } from '@/types.ts';
import { responsive } from '@/utils';

import {
  StyledFooterLanguageSlot,
  StyledModalContent,
  StyledShortcutsModal,
} from './shortcutsDialog.styles.ts';
import {
  CameraShortcuts,
  GlobalShortcuts,
  InventoryShortcuts,
  LayoutPickerShortcuts,
  LayoutShortcuts,
  ShortcutPages,
  ShortcutsPageTabs,
} from './shortcutsDialog/';

type ShortcutsDialogProps = {
  modalController: ModalControllerType;
};

export const ShortcutsDialog = ({ modalController }: ShortcutsDialogProps) => {
  const { t } = useTranslation(['common']);
  const [currentShortcutPage, setCurrentShortcutPage] = useState<ShortcutPages>(
    ShortcutPages.global
  );

  return (
    <StyledShortcutsModal
      closeOnBackdropClick
      closeOnEscapeClick
      open={modalController.open}
      onClose={modalController.onClose}
      $width={'fit-content'}
    >
      <ModalHeader title={t('shortcuts.modalHeader')} onClose={modalController.onClose} />
      <StyledModalContent>
        <FlexAligner alignment='center' direction='column' gap={responsive.spacing.xlarge}>
          <ShortcutsPageTabs
            currentShortCutPage={currentShortcutPage}
            onPageTabChange={setCurrentShortcutPage}
          />
          {currentShortcutPage === ShortcutPages.layout && <LayoutShortcuts />}
          {currentShortcutPage === ShortcutPages.layoutPicker && <LayoutPickerShortcuts />}
          {currentShortcutPage === ShortcutPages.global && <GlobalShortcuts />}
          {currentShortcutPage === ShortcutPages.inventory && <InventoryShortcuts />}
          {currentShortcutPage === ShortcutPages.cameras && <CameraShortcuts />}
          {currentShortcutPage === ShortcutPages.gamePad && (
            <div
              style={{
                paddingLeft: responsive.spacing['5xlarge'],
                paddingRight: responsive.spacing['5xlarge'],
              }}
            >
              <GamepadLayoutScreen withTitle />
            </div>
          )}
        </FlexAligner>
      </StyledModalContent>
      <ModalFooter actionButtons={[{ label: t('close'), onClick: modalController.onClose }]} />
      <StyledFooterLanguageSlot>
        <LanguageSelector />
      </StyledFooterLanguageSlot>
    </StyledShortcutsModal>
  );
};
